<script>
import moment from "moment";
import { attendStatusList, checkinStatusList, findLabel, downloadBlob } from "../help";
import {
  getTechActivityList,
  getInviteRecords,
  exportInviteRecords,
} from "@/api/techInnoActivities";

export default {
  name: "TechInnoInviteRecords",
  data() {
    return {
      moment,
      attendStatusList,
      checkinStatusList,
      // 活动下拉数据
      activityOptions: [],
      // 搜索条件
      searchForm: {
        // 活动（不选则查全部）
        activityId: undefined,
        // 手机号
        phone: "",
        // 受邀人姓名
        userName: "",
        // 受邀人企业
        companyName: "",
        // 邀请人姓名（模糊）
        inviterName: "",
        // 参会情况（不选则查全部）
        attendStatus: "",
        // 签到状态（不选则查全部）
        checkinStatus: "",
      },
      columns: [
        { title: "活动名称", dataIndex: "activityName", key: "activityName", width: 180, ellipsis: true },
        { title: "邀请人姓名", dataIndex: "inviterName", key: "inviterName", width: 110, ellipsis: true, customRender: (text) => text || "--" },
        { title: "受邀人名字", dataIndex: "userName", key: "userName", width: 110, ellipsis: true, customRender: (text) => text || "--" },
        { title: "受邀人企业", dataIndex: "companyName", key: "companyName", width: 170, ellipsis: true, customRender: (text) => text || "--" },
        { title: "受邀人手机号", dataIndex: "phone", key: "phone", width: 130, ellipsis: true, customRender: (text) => text || "--" },
        { title: "身份类型", dataIndex: "identityName", key: "identityName", width: 130, ellipsis: true, customRender: (text) => text || "--" },
        {
          title: "参会情况",
          key: "attendStatus",
          width: 110,
          ellipsis: true,
          customRender: (text, record) => findLabel(attendStatusList, record.attendStatus) || "--",
        },
        {
          title: "签到情况",
          key: "checkinStatus",
          width: 110,
          ellipsis: true,
          customRender: (text, record) => {
            // 活动无需签到时不展示签到情况（checkinStatus 恒为 0 但不渲染）
            if (record.needCheckin === 0) return "--";
            return findLabel(checkinStatusList, record.checkinStatus) || "--";
          },
        },
        { title: "受邀时间", dataIndex: "createTime", key: "createTime", width: 170 },
      ],
      dataInfo: [],
      listLoading: false,
      // 导出 loading
      exportLoading: false,
      pagination: {
        pageSizeOptions: ["10", "20", "30", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
    };
  },
  created() {
    this.getActivityOptions();
    this.getList();
  },
  methods: {
    /**
     * @Description：活动下拉数据
     * @Author cxd
     * @Date 2026/10/31
     */
    async getActivityOptions() {
      try {
        const res = await getTechActivityList({ page: 1, size: 999 });
        if (String(res.code) === "200") {
          this.activityOptions = (res.data && res.data.items) || [];
        }
      } catch (e) {
        this.activityOptions = [];
      }
    },
    /**
     * @Description：受邀记录列表（接口 page 从 1 开始）
     * @Author cxd
     * @Date 2026/10/31
     */
    async getList() {
      const params = {
        activityId: this.searchForm.activityId,
        phone: this.searchForm.phone,
        userName: this.searchForm.userName,
        companyName: this.searchForm.companyName,
        inviterName: this.searchForm.inviterName,
        attendStatus: this.searchForm.attendStatus,
        checkinStatus: this.searchForm.checkinStatus,
        page: this.pagination.current,
        size: this.pagination.pageSize,
      };
      this.listLoading = true;
      try {
        const res = await getInviteRecords(params);
        if (String(res.code) === "200") {
          this.dataInfo = (res.data && res.data.items) || [];
          this.pagination.total = (res.data && res.data.total) || 0;
        } else {
          this.$message.error(res.msg || "查询失败");
        }
      } catch (e) {
        this.$message.error("查询失败");
      } finally {
        this.listLoading = false;
      }
    },
    /**
     * @Description：查询
     * @Author cxd
     * @Date 2026/10/31
     */
    search() {
      this.pagination.current = 1;
      this.getList();
    },
    /**
     * @Description：重置
     * @Author cxd
     * @Date 2026/10/31
     */
    resetSearchForm() {
      this.searchForm = {
        activityId: undefined,
        phone: "",
        userName: "",
        companyName: "",
        inviterName: "",
        attendStatus: "",
        checkinStatus: "",
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getList();
    },
    /**
     * @Description：分页
     * @Author cxd
     * @Date 2026/10/31
     */
    pageChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList();
    },
    /**
     * @Description：受邀记录导出（按当前筛选条件，条件全空=全量）
     * @Author cxd
     * @Date 2026/10/31
     */
    async handleExport() {
      this.exportLoading = true;
      try {
        const res = await exportInviteRecords({
          activityId: this.searchForm.activityId,
          phone: this.searchForm.phone,
          userName: this.searchForm.userName,
          companyName: this.searchForm.companyName,
          inviterName: this.searchForm.inviterName,
          attendStatus: this.searchForm.attendStatus,
          checkinStatus: this.searchForm.checkinStatus,
        });
        downloadBlob(res, `邀约记录-${moment().format("YYYYMMDDHHmmss")}.xlsx`);
      } catch (e) {
        this.$message.error("导出失败，请稍后重试");
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<template>
  <div class="tech-inno-invite-records">
    <ds-header title="邀约记录管理"></ds-header>
    <a-form layout="inline" style="margin-bottom: 10px">
      <a-form-item label="活动：">
        <a-select
          v-model="searchForm.activityId"
          placeholder="请选择活动"
          style="width: 220px"
          allowClear
          show-search
          option-filter-prop="children"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option
            v-for="item in activityOptions"
            :key="item.id"
            :value="String(item.id)"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="手机号：">
        <a-input
          v-model.trim="searchForm.phone"
          placeholder="请输入手机号"
          style="width: 160px"
        />
      </a-form-item>
      <a-form-item label="受邀人姓名：">
        <a-input v-model.trim="searchForm.userName" placeholder="请输入姓名" style="width: 130px" />
      </a-form-item>
      <a-form-item label="受邀人企业：">
        <a-input
          v-model.trim="searchForm.companyName"
          placeholder="请输入企业"
          style="width: 160px"
        />
      </a-form-item>
      <a-form-item label="邀请人姓名：">
        <a-input
          v-model.trim="searchForm.inviterName"
          placeholder="请输入邀请人姓名"
          style="width: 140px"
        />
      </a-form-item>
      <a-form-item label="参会情况：">
        <a-select
          v-model="searchForm.attendStatus"
          placeholder="请选择"
          style="width: 150px"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value=""> 全部状态 </a-select-option>
          <a-select-option v-for="item in attendStatusList" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="签到状态：">
        <a-select
          v-model="searchForm.checkinStatus"
          placeholder="请选择"
          style="width: 150px"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value=""> 全部状态 </a-select-option>
          <a-select-option v-for="item in checkinStatusList" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <span>
        <a-button type="primary" style="margin-top: 3px" icon="search" @click="search">
          查询
        </a-button>
        <a-button style="margin-left: 15px" icon="redo" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>
    <div style="margin-top: 15px">
      <div class="toolbar">
        <a-button type="primary" icon="download" :loading="exportLoading" @click="handleExport">
          导出
        </a-button>
      </div>
      <a-table
        :rowKey="(record) => record.id"
        :columns="columns"
        :data-source="dataInfo"
        :loading="listLoading"
        :pagination="pagination.total ? pagination : false"
        :scroll="{ x: 1230 }"
        bordered
        @change="pageChange"
      >
      </a-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.toolbar {
  margin-bottom: 10px;
}
</style>
